import React from "react";
import { motion } from "framer-motion";

// Line-by-line masked reveal for headings
export function RevealLines({ lines, className = "", stagger = 0.08, delay = 0.15 }) {
  const ease = [0.76, 0, 0.24, 1];
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="pp-line-mask">
          <motion.span
            style={{ display: "inline-block", willChange: "transform" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Word-by-word reveal on view
export function RevealWords({ text, className = "", stagger = 0.05 }) {
  const ease = [0.76, 0, 0.24, 1];
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="pp-line-mask" style={{ display: "inline-block", marginRight: "0.28em" }}>
          <motion.span
            style={{ display: "inline-block" }}
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.85, ease, delay: i * stagger }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Fade + rise on view
export function Rise({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
